import React from "react";
import { Link } from "react-router-dom";
import { formatPrice } from "../../utils/helpers";
import "./Product.scss";
import { IMAGE_URL1 } from "../../utils/apiURL";


const Product = ({ product }) => {
  return (
    <Link to={`/product/${product?.id}`} key={product?.id}>
      <div className="product-item bg-white">
        <div className="category">{product?.categories_name}</div>
        <div className="product-item-img">
          <img
            className="img-cover"
            src={`${IMAGE_URL1}${product?.product_images1}`}
            alt={product.product_name}
          />
        </div>
        <div className="product-item-info fs-14">
          <div className="brand">
            <span>Remaining stock: </span>
            <span className="fw-7">{product?.stock}</span>
          </div>
          <div className="title py-2">{product?.product_name}</div>
          <div className="price flex align-center justify-center">
            <span className="new-price">{formatPrice(product?.price)}</span>           
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Product;